import { PipeTransform, Pipe } from '@angular/core';
import ProductHelper from '../helpers/product-helper';
import { StringHelper } from '../helpers/string-helper';

@Pipe({
  name: 'productType'
})
export class ProductTypePipe implements PipeTransform {
  transform(type: string, otherProductName: string, format = '') {
    return (
      ProductHelper.getType(type, otherProductName) +
      (StringHelper.isEmpty(format) ? '' : ': ' + format)
    );
  }
}
